
import { mdiViewList, mdiViewComfy } from '@mdi/js';
const defaultLayout = 'list';
export default {
  props: {
    value: { type: String, default: defaultLayout },
    layouts: {
      type: Array,
      default: () => [
        { icon: mdiViewList, value: 'list', label: 'List' },
        { icon: mdiViewComfy, value: 'columns', label: 'Grid' },
      ],
    },
  },
  computed: {
    currentLayout() {
      const vm = this;
      return vm.layouts.find((layout) => {
        return (vm.value || defaultLayout) === layout.value;
      });
    },
    availableLayouts() {
      const vm = this;
      return vm.layouts.filter(
        (layout) => (vm.value || defaultLayout) !== layout.value,
      );
    },
    inputListeners() {
      // Allow other events to be bound
      const vm = this;
      return Object.assign({}, this.$listeners, {
        input(event) {
          vm.$emit('input', event);
        },
      });
    },
  },
};
